// extracted by mini-css-extract-plugin
export var loadingShimmer = "_rk-2";
export var messageContent = "_rk-0";
export var messagesScroll = "_rk-1";
export var shimmer = "_rk-3";
export var shimmerW100 = "_rk-4";
export var shimmerW70 = "_rk-8";
export var shimmerW80 = "_rk-7";
export var shimmerW85 = "_rk-6";
export var shimmerW90 = "_rk-5";